export default "__VITE_ASSET__D9VX67x4__"